// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__UaR0I","header":"MessagesList_header__3eAaH","chat":"MessagesList_chat__3y2bl"};